var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var dist = {};
var doc$1 = {};
var hasRequiredDoc$1;
function requireDoc$1() {
  if (hasRequiredDoc$1) return doc$1;
  hasRequiredDoc$1 = 1;
  Object.defineProperty(doc$1, "__esModule", { value: true });
  doc$1.getDoc = getDoc;
  function getDoc(sdk2) {
    return {
      // 获取文档长度
      getDocLength: sdk2.doc.getDocLength,
      // 更新文档选中内容
      setDocSelectionData: sdk2.doc.setDocSelectionData,
      // 获取文档选中内容
      getSelectionContent: sdk2.doc.getSelectionContent,
      // 监听文档选中内容变化
      onSelectionChange: sdk2.doc.onSelectionChange,
      // 获取文档内容
      getDocContent: sdk2.doc.getDocContent,
      // 获取文档的id
      getDocId: sdk2.doc.getDocId,
      // 获取文档的rte token
      getDocToken: sdk2.doc.getDocToken,
      // 获取文档基础信息
      getDocBaseInfo: sdk2.doc.getDocBaseInfo,
      // 获取目录树数据
      getSideBarData: sdk2.doc.getSideBarData,
      // 获取文档权限
      getDocPermission: sdk2.doc.getDocPermission,
      // 获取文档模式
      getDocMode: sdk2.doc.getDocMode,
      // 获取文档静态化 html
      getDocStaticHtml: sdk2.doc.getDocStaticHtml,
      // 获取文档附件数据
      getDocAttachData: sdk2.doc.getDocAttachData,
      // 获取文档是否处于演示模式
      getIsDemoMode: sdk2.doc.getIsDemoMode
    };
  }
  __name(getDoc, "getDoc");
  return doc$1;
}
__name(requireDoc$1, "requireDoc$1");
var repository = {};
var hasRequiredRepository;
function requireRepository() {
  if (hasRequiredRepository) return repository;
  hasRequiredRepository = 1;
  Object.defineProperty(repository, "__esModule", { value: true });
  repository.getRepository = getRepository;
  function getRepository(sdk2) {
    return {
      getRepoBaseInfo: sdk2.repository.getRepoBaseInfo,
      getRepoPermission: sdk2.repository.getRepoPermission
    };
  }
  __name(getRepository, "getRepository");
  return repository;
}
__name(requireRepository, "requireRepository");
var component = {};
var hasRequiredComponent;
function requireComponent() {
  if (hasRequiredComponent) return component;
  hasRequiredComponent = 1;
  Object.defineProperty(component, "__esModule", { value: true });
  component.getComponent = getComponent;
  function getComponent(sdk2) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12;
    return {
      showConfirm: (_a = sdk2.component) === null || _a === void 0 ? void 0 : _a.showConfirm,
      showToast: (_b = sdk2.component) === null || _b === void 0 ? void 0 : _b.showToast,
      showDialog: (_c = sdk2.component) === null || _c === void 0 ? void 0 : _c.showDialog,
      Button: (_e = (_d = sdk2.component) === null || _d === void 0 ? void 0 : _d.Button) !== null && _e !== void 0 ? _e : (function() {
        return null;
      }),
      Icon: (_g = (_f = sdk2.component) === null || _f === void 0 ? void 0 : _f.Icon) !== null && _g !== void 0 ? _g : (function() {
        return null;
      }),
      CloseX: (_j = (_h = sdk2.component) === null || _h === void 0 ? void 0 : _h.CloseX) !== null && _j !== void 0 ? _j : (function() {
        return null;
      }),
      Dialog: (_l = (_k = sdk2.component) === null || _k === void 0 ? void 0 : _k.Dialog) !== null && _l !== void 0 ? _l : (function() {
        return null;
      }),
      Collapse: (_o = (_m = sdk2.component) === null || _m === void 0 ? void 0 : _m.Collapse) !== null && _o !== void 0 ? _o : (function() {
        return null;
      }),
      CollapsePanel: (_q = (_p = sdk2.component) === null || _p === void 0 ? void 0 : _p.CollapsePanel) !== null && _q !== void 0 ? _q : (function() {
        return null;
      }),
      Popover: (_s = (_r = sdk2.component) === null || _r === void 0 ? void 0 : _r.Popover) !== null && _s !== void 0 ? _s : (function() {
        return null;
      }),
      Tooltip: (_u = (_t = sdk2.component) === null || _t === void 0 ? void 0 : _t.Tooltip) !== null && _u !== void 0 ? _u : (function() {
        return null;
      }),
      EllipsisTooltip: (_w = (_v = sdk2.component) === null || _v === void 0 ? void 0 : _v.EllipsisTooltip) !== null && _w !== void 0 ? _w : (function() {
        return null;
      }),
      Input: (_y = (_x = sdk2.component) === null || _x === void 0 ? void 0 : _x.Input) !== null && _y !== void 0 ? _y : (function() {
        return null;
      }),
      Select: (_0 = (_z = sdk2.component) === null || _z === void 0 ? void 0 : _z.Select) !== null && _0 !== void 0 ? _0 : (function() {
        return null;
      }),
      Switch: (_2 = (_1 = sdk2.component) === null || _1 === void 0 ? void 0 : _1.Switch) !== null && _2 !== void 0 ? _2 : (function() {
        return null;
      }),
      Avatar: (_4 = (_3 = sdk2.component) === null || _3 === void 0 ? void 0 : _3.Avatar) !== null && _4 !== void 0 ? _4 : (function() {
        return null;
      }),
      Table: (_6 = (_5 = sdk2.component) === null || _5 === void 0 ? void 0 : _5.Table) !== null && _6 !== void 0 ? _6 : (function() {
        return null;
      }),
      Loading: (_8 = (_7 = sdk2.component) === null || _7 === void 0 ? void 0 : _7.Loading) !== null && _8 !== void 0 ? _8 : (function() {
        return null;
      }),
      RangePicker: (_10 = (_9 = sdk2.component) === null || _9 === void 0 ? void 0 : _9.RangePicker) !== null && _10 !== void 0 ? _10 : (function() {
        return null;
      }),
      showFlowCardDialog: (_12 = (_11 = sdk2.component) === null || _11 === void 0 ? void 0 : _11.showFlowCardDialog) !== null && _12 !== void 0 ? _12 : (function() {
        return null;
      })
    };
  }
  __name(getComponent, "getComponent");
  return component;
}
__name(requireComponent, "requireComponent");
var user = {};
var hasRequiredUser;
function requireUser() {
  if (hasRequiredUser) return user;
  hasRequiredUser = 1;
  Object.defineProperty(user, "__esModule", { value: true });
  user.getUser = getUser;
  function getUser(sdk2) {
    return {
      getUserInfo: sdk2.user.getUserInfo,
      getCreatorInfo: sdk2.user.getCreatorInfo
    };
  }
  __name(getUser, "getUser");
  return user;
}
__name(requireUser, "requireUser");
var utils$2 = {};
var hasRequiredUtils$2;
function requireUtils$2() {
  if (hasRequiredUtils$2) return utils$2;
  hasRequiredUtils$2 = 1;
  Object.defineProperty(utils$2, "__esModule", { value: true });
  utils$2.getUtils = getUtils;
  function getUtils(sdk2) {
    return {
      request: sdk2.utils.request,
      axios: sdk2.utils.axios,
      ksRequest: sdk2.utils.ksRequest,
      asRequest: sdk2.utils.asRequest,
      rteRequest: sdk2.utils.rteRequest,
      kuLogger: sdk2.utils.kuLogger,
      dayjs: sdk2.utils.dayjs,
      getToken: sdk2.utils.getToken,
      getServerConfig: sdk2.utils.getServerConfig,
      registerKuHotKey: sdk2.utils.registerKuHotKey,
      unregisterKuHotKey: sdk2.utils.unregisterKuHotKey,
      getRegisteredHotkeys: sdk2.utils.getRegisteredHotkeys,
      hotkeyTrim: sdk2.utils.hotkeyTrim,
      isInKuShare: sdk2.utils.isInKuShare,
      classnames: sdk2.utils.classnames,
      lodash: sdk2.utils.lodash
    };
  }
  __name(getUtils, "getUtils");
  return utils$2;
}
__name(requireUtils$2, "requireUtils$2");
var init = {};
var utils$1 = {};
var hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$1;
  hasRequiredUtils$1 = 1;
  Object.defineProperty(utils$1, "__esModule", { value: true });
  utils$1.RepType = void 0;
  var RepType;
  (function(RepType2) {
    RepType2["Click"] = "click";
    RepType2["Show"] = "show";
  })(RepType || (utils$1.RepType = RepType = {}));
  return utils$1;
}
__name(requireUtils$1, "requireUtils$1");
var hasRequiredInit;
function requireInit() {
  if (hasRequiredInit) return init;
  hasRequiredInit = 1;
  var __assign = init && init.__assign || function() {
    __assign = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  Object.defineProperty(init, "__esModule", { value: true });
  init.getSlot = void 0;
  init.initSideBarTool = initSideBarTool;
  init.initDropMenuTool = initDropMenuTool;
  var utils_1 = requireUtils$1();
  var LogIdMap = {
    initDropMenuTool: "80001.2.291"
    // 注册更多菜单工具
  };
  function initSideBarTool(sdk2, params, extensionLoader, sdkFromHost) {
    var id = params.id;
    var appId = sdk2.id || id;
    if (!appId) {
      throw Error("tool load error, appId is undefined");
    }
    sdk2.id = appId;
    var realParams = __assign(__assign({}, params), { id: appId, debug: sdk2.debug });
    extensionLoader.setApiParam("initSideBarTool", appId, [realParams]);
    sdkFromHost.slot.initSideBarTool(realParams);
  }
  __name(initSideBarTool, "initSideBarTool");
  function reportInitDropMenuTool(sdk2, data) {
    var docGuid = sdk2.doc.getDocBaseInfo().docId;
    sdk2.utils.kuLogger({
      repId: LogIdMap.initDropMenuTool,
      params: __assign(__assign({}, data), { docId: docGuid }),
      type: utils_1.RepType.Click
    });
  }
  __name(reportInitDropMenuTool, "reportInitDropMenuTool");
  function initDropMenuTool(sdk2, params, extensionLoader, sdkFromHost) {
    var id = params.id, name = params.name;
    var appId = sdk2.id || id;
    if (!appId || !name) {
      throw Error("tool load error, appId or name is undefined");
    }
    sdk2.id = appId;
    var realParams = __assign(__assign({}, params), { id: appId, debug: sdk2.debug });
    extensionLoader.setApiParam("initDropMenuTool", appId, [realParams]);
    reportInitDropMenuTool(sdk2, { id: appId });
    sdkFromHost.slot.initDropMenuTool(realParams);
  }
  __name(initDropMenuTool, "initDropMenuTool");
  var getSlot = /* @__PURE__ */ __name(function(instance, extensionLoader, sdkFromHost) {
    return {
      initSideBarTool: /* @__PURE__ */ __name(function(opts) {
        return initSideBarTool(instance, opts, extensionLoader, sdkFromHost);
      }, "initSideBarTool"),
      initDropMenuTool: /* @__PURE__ */ __name(function(opts) {
        return initDropMenuTool(instance, opts, extensionLoader, sdkFromHost);
      }, "initDropMenuTool")
    };
  }, "getSlot");
  init.getSlot = getSlot;
  return init;
}
__name(requireInit, "requireInit");
var log = {};
var hasRequiredLog;
function requireLog() {
  if (hasRequiredLog) return log;
  hasRequiredLog = 1;
  Object.defineProperty(log, "__esModule", { value: true });
  log.appLog = void 0;
  log.appLog = {
    log: /* @__PURE__ */ __name(function(text, data) {
      var style = "background: green; padding: 3px; border-radius: 2px;";
      console.log("%c ".concat(text), style, data);
    }, "log"),
    error: /* @__PURE__ */ __name(function(text, data) {
      var style = "background: red; padding: 3px; border-radius: 2px;";
      console.error("%c ".concat(text), style, data);
    }, "error")
  };
  return log;
}
__name(requireLog, "requireLog");
var bus = {};
var common = {};
var hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common;
  hasRequiredCommon = 1;
  Object.defineProperty(common, "__esModule", { value: true });
  common.arrayToObject = arrayToObject;
  common.getWindowSDK = getWindowSDK;
  common.isNoNeedLog = isNoNeedLog;
  function arrayToObject(array, keyField) {
    return array.reduce(function(obj, item) {
      var key = String(item[keyField]);
      obj[key] = item;
      return obj;
    }, {});
  }
  __name(arrayToObject, "arrayToObject");
  function getWindowSDK() {
    return window.__KU_TOOL_SDK__;
  }
  __name(getWindowSDK, "getWindowSDK");
  function isNoNeedLog(fnName) {
    return [
      "classnames",
      "render"
    ].includes(fnName);
  }
  __name(isNoNeedLog, "isNoNeedLog");
  return common;
}
__name(requireCommon, "requireCommon");
var hasRequiredBus;
function requireBus() {
  if (hasRequiredBus) return bus;
  hasRequiredBus = 1;
  var _a, _b;
  Object.defineProperty(bus, "__esModule", { value: true });
  bus.getKuToolEvent = getKuToolEvent;
  var common_1 = requireCommon();
  var wikiKuToolEvent = (_b = (_a = window.__KU_TOOL_SDK__) === null || _a === void 0 ? void 0 : _a.getKuToolEvent) === null || _b === void 0 ? void 0 : _b.call(_a);
  function getKuToolEvent(sdkOptions, debug) {
    var kuToolEvent = {
      on: /* @__PURE__ */ __name(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("on", sdkOptions.appId, [args]);
        return wikiKuToolEvent.on.apply(wikiKuToolEvent, args);
      }, "on"),
      off: /* @__PURE__ */ __name(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("off", sdkOptions.appId, [args]);
        return wikiKuToolEvent.off.apply(wikiKuToolEvent, args);
      }, "off"),
      once: /* @__PURE__ */ __name(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("once", sdkOptions.appId, [args]);
        return wikiKuToolEvent.once.apply(wikiKuToolEvent, args);
      }, "once"),
      emit: /* @__PURE__ */ __name(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("emit", sdkOptions.appId, [args]);
        return wikiKuToolEvent.emit.apply(wikiKuToolEvent, args);
      }, "emit")
    };
    return kuToolEvent;
  }
  __name(getKuToolEvent, "getKuToolEvent");
  return bus;
}
__name(requireBus, "requireBus");
var blockSdk = {};
var core = {};
var bridge = {};
var utils = {};
var constant = {};
var hasRequiredConstant;
function requireConstant() {
  if (hasRequiredConstant) return constant;
  hasRequiredConstant = 1;
  Object.defineProperty(constant, "__esModule", { value: true });
  constant.NOTIFY_TYPE = constant.EVENT_RESPONSE_TYPE = constant.EVENT_REGISTER_TYPE = constant.API_RESPONSE_TYPE = constant.API_REQUEST_TYPE = constant.msgIdPrefix = void 0;
  constant.msgIdPrefix = "ku-block-sdk-";
  constant.API_REQUEST_TYPE = "ku-block-api-request";
  constant.API_RESPONSE_TYPE = "ku-block-api-response";
  constant.EVENT_REGISTER_TYPE = "ku-block-event-register";
  constant.EVENT_RESPONSE_TYPE = "ku-block-event-response";
  constant.NOTIFY_TYPE = "ku-block-notify";
  return constant;
}
__name(requireConstant, "requireConstant");
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils;
  hasRequiredUtils = 1;
  Object.defineProperty(utils, "__esModule", { value: true });
  utils.genMsgId = genMsgId;
  utils.isEventAPI = isEventAPI;
  utils.isNotifyAPI = isNotifyAPI;
  utils.isNeedFormatData = isNeedFormatData;
  utils.getFormatData = getFormatData;
  var constant_1 = requireConstant();
  function genMsgId() {
    var uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2, 5);
    return constant_1.msgIdPrefix + uniqueId;
  }
  __name(genMsgId, "genMsgId");
  function isEventAPI(name) {
    var scope = name.split(".")[0];
    return scope === "event";
  }
  __name(isEventAPI, "isEventAPI");
  function isNotifyAPI(name) {
    var scope = name.split(".")[0];
    return scope === "notify";
  }
  __name(isNotifyAPI, "isNotifyAPI");
  function isNeedFormatData(scope) {
    if (!Array.isArray(scope)) {
      return false;
    }
    return scope[1] === "updateHeight";
  }
  __name(isNeedFormatData, "isNeedFormatData");
  function getFormatData(scope, data) {
    if (!Array.isArray(data) || !isNeedFormatData(scope)) {
      return data;
    }
    if (scope[1] === "updateHeight") {
      return {
        height: data[0]
      };
    }
    return data;
  }
  __name(getFormatData, "getFormatData");
  return utils;
}
__name(requireUtils, "requireUtils");
var hasRequiredBridge;
function requireBridge() {
  if (hasRequiredBridge) return bridge;
  hasRequiredBridge = 1;
  Object.defineProperty(bridge, "__esModule", { value: true });
  bridge.Bridge = void 0;
  var utils_1 = requireUtils();
  var constant_1 = requireConstant();
  var Bridge = (
    /** @class */
    /* @__PURE__ */ (function() {
      function Bridge2() {
        var _this = this;
        this.apiRequestCallbacks = {};
        this.eventCallbacks = {};
        this.postMessage = function(data) {
          window.parent.postMessage(data, "*");
        };
        this.request = function(_a) {
          var name = _a.name, data = _a.data, appId = _a.appId;
          var id = (0, utils_1.genMsgId)();
          if ((0, utils_1.isEventAPI)(name)) {
            _this.eventCallbacks[id] = data;
            _this.postMessage({
              id,
              type: constant_1.EVENT_REGISTER_TYPE,
              name,
              appId
            });
            return;
          }
          if ((0, utils_1.isNotifyAPI)(name)) {
            _this.postMessage({
              id,
              type: constant_1.NOTIFY_TYPE,
              appId,
              data,
              action: name.split(".")[1]
            });
            return;
          }
          return new Promise(function(resolve, reject) {
            _this.apiRequestCallbacks[id] = {
              resolve,
              reject
            };
            _this.postMessage({
              id,
              type: constant_1.API_REQUEST_TYPE,
              name,
              appId,
              data
            });
          });
        };
        this.handleMessage = function(event2) {
          var _a = event2.data, id = _a.id, type = _a.type, body = _a.body;
          if (!id) {
            return;
          }
          if (type === constant_1.API_RESPONSE_TYPE) {
            var message = body.message, code = body.code, data = body.data;
            var cb = _this.apiRequestCallbacks[id];
            if (code !== 200) {
              cb && cb.reject({ code, message });
            } else {
              cb && cb.resolve(data);
            }
            delete _this.apiRequestCallbacks[id];
          } else if (type === constant_1.EVENT_RESPONSE_TYPE) {
            var data = body.data;
            var cb = _this.eventCallbacks[id];
            cb && cb(data);
          }
        };
        this.destroy = function() {
          window.removeEventListener("message", _this.handleMessage);
        };
        window.addEventListener("message", this.handleMessage);
      }
      __name(Bridge2, "Bridge");
      return Bridge2;
    })()
  );
  bridge.Bridge = Bridge;
  return bridge;
}
__name(requireBridge, "requireBridge");
var runtime = {};
var hasRequiredRuntime;
function requireRuntime() {
  if (hasRequiredRuntime) return runtime;
  hasRequiredRuntime = 1;
  var __awaiter = runtime && runtime.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    __name(adopt, "adopt");
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      __name(fulfilled, "fulfilled");
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      __name(rejected, "rejected");
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      __name(step, "step");
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __generator = runtime && runtime.__generator || function(thisArg, body) {
    var _ = { label: 0, sent: /* @__PURE__ */ __name(function() {
      if (t[0] & 1) throw t[1];
      return t[1];
    }, "sent"), trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function verb(n) {
      return function(v) {
        return step([n, v]);
      };
    }
    __name(verb, "verb");
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
    __name(step, "step");
  };
  Object.defineProperty(runtime, "__esModule", { value: true });
  runtime.RunTime = void 0;
  var RunTime = (
    /** @class */
    (function() {
      function RunTime2() {
      }
      __name(RunTime2, "RunTime");
      RunTime2.prototype.onInvokeAPI = function(func) {
        if (func && this.invokeAPIFunc) {
          console.warn("duplicated runtime.onApiInvoke");
        }
        this.invokeAPIFunc = func;
      };
      RunTime2.prototype.makeAPI = function(scope) {
        var _this = this;
        var scopes = [scope];
        var invoke = /* @__PURE__ */ __name(function() {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return __awaiter(_this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              if (!this.invokeAPIFunc) {
                throw new Error("Runtime API invocation function is missing");
              }
              return [2, this.invokeAPIFunc({
                data,
                scopes
              })];
            });
          });
        }, "invoke");
        invoke.__scopes = scopes;
        return invoke;
      };
      RunTime2.prototype.makeScope = function(scope, apiMap) {
        Object.values(apiMap).forEach(function(apiFunc) {
          var scopes = apiFunc.__scopes || [];
          scopes.unshift(scope);
        });
        return apiMap;
      };
      return RunTime2;
    })()
  );
  runtime.RunTime = RunTime;
  return runtime;
}
__name(requireRuntime, "requireRuntime");
var hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core;
  hasRequiredCore = 1;
  Object.defineProperty(core, "__esModule", { value: true });
  core.BlockSDK = void 0;
  var bridge_1 = requireBridge();
  var runtime_1 = requireRuntime();
  var utils_1 = requireUtils();
  var runtime2 = new runtime_1.RunTime();
  var doc2 = {
    getDocContent: runtime2.makeAPI("getDocContent"),
    getDocBaseInfo: runtime2.makeAPI("getDocBaseInfo"),
    getSideBarData: runtime2.makeAPI("getSideBarData"),
    getDocPermission: runtime2.makeAPI("getDocPermission"),
    getDocMode: runtime2.makeAPI("getDocMode"),
    getDocStaticHtml: runtime2.makeAPI("getDocStaticHtml"),
    getDocAttachData: runtime2.makeAPI("getDocAttachData"),
    getDocToken: runtime2.makeAPI("getDocToken")
  };
  var repository2 = {
    getRepoBaseInfo: runtime2.makeAPI("getRepoBaseInfo"),
    getRepoPermission: runtime2.makeAPI("getRepoPermission")
  };
  var user2 = {
    getUserInfo: runtime2.makeAPI("getUserInfo"),
    getCreatorInfo: runtime2.makeAPI("getCreatorInfo")
  };
  var event2 = {
    onDocSave: runtime2.makeAPI("onDocSave")
  };
  var utils2 = {
    ksRequest: runtime2.makeAPI("ksRequest"),
    asRequest: runtime2.makeAPI("asRequest"),
    rteRequest: runtime2.makeAPI("rteRequest"),
    request: runtime2.makeAPI("request"),
    axios: runtime2.makeAPI("axios"),
    kuLogger: runtime2.makeAPI("kuLogger"),
    getToken: runtime2.makeAPI("getToken"),
    getServerConfig: runtime2.makeAPI("getServerConfig")
  };
  var notify = {
    updateHeight: runtime2.makeAPI("updateHeight"),
    pageLoaded: runtime2.makeAPI("pageLoaded")
  };
  var component2 = {
    showConfirm: runtime2.makeAPI("showConfirm"),
    showToast: runtime2.makeAPI("showToast")
  };
  var BlockAPI = {
    doc: runtime2.makeScope("doc", doc2),
    repository: runtime2.makeScope("repository", repository2),
    user: runtime2.makeScope("user", user2),
    event: runtime2.makeScope("event", event2),
    utils: runtime2.makeScope("utils", utils2),
    notify: runtime2.makeScope("notify", notify),
    component: runtime2.makeScope("component", component2)
  };
  var BlockSDK = (
    /** @class */
    (function() {
      function BlockSDK2(options) {
        var _this = this;
        BlockSDK2.appId = options.appId;
        this.bridge = new bridge_1.Bridge();
        this.invokeAPI = function(_a) {
          var data = _a.data, scopes = _a.scopes;
          var apiData = data[0];
          if ((0, utils_1.isNeedFormatData)(scopes)) {
            apiData = (0, utils_1.getFormatData)(scopes, data);
          }
          return _this.bridge.request({
            name: scopes.join("."),
            data: apiData,
            appId: BlockSDK2.appId
          });
        };
      }
      __name(BlockSDK2, "BlockSDK");
      BlockSDK2.prototype.init = function() {
        runtime2.onInvokeAPI(this.invokeAPI);
        return BlockAPI;
      };
      BlockSDK2.appId = "";
      return BlockSDK2;
    })()
  );
  core.BlockSDK = BlockSDK;
  return core;
}
__name(requireCore, "requireCore");
var hasRequiredBlockSdk;
function requireBlockSdk() {
  if (hasRequiredBlockSdk) return blockSdk;
  hasRequiredBlockSdk = 1;
  Object.defineProperty(blockSdk, "__esModule", { value: true });
  blockSdk.createBlockSDK = void 0;
  var core_1 = requireCore();
  var createBlockSDK = /* @__PURE__ */ __name(function(options) {
    var BlockAPI = new core_1.BlockSDK(options).init();
    return BlockAPI;
  }, "createBlockSDK");
  blockSdk.createBlockSDK = createBlockSDK;
  return blockSdk;
}
__name(requireBlockSdk, "requireBlockSdk");
var editorExtension = {};
var sdk = {};
var hasRequiredSdk;
function requireSdk() {
  if (hasRequiredSdk) return sdk;
  hasRequiredSdk = 1;
  Object.defineProperty(sdk, "__esModule", { value: true });
  sdk.VersionOfCreateServiceExtension = void 0;
  sdk.VersionOfCreateServiceExtension = "2";
  return sdk;
}
__name(requireSdk, "requireSdk");
var hasRequiredEditorExtension;
function requireEditorExtension() {
  if (hasRequiredEditorExtension) return editorExtension;
  hasRequiredEditorExtension = 1;
  var __spreadArray = editorExtension && editorExtension.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  };
  Object.defineProperty(editorExtension, "__esModule", { value: true });
  editorExtension.getEditorExtension = getEditorExtension;
  var sdk_1 = requireSdk();
  var common_1 = requireCommon();
  function getEditorExtension(sdk2, sdkOptions, debug) {
    return {
      /**
       * 创建内容插件
       */
      createContentExtension: /* @__PURE__ */ __name(function() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("createContentExtension", sdkOptions.appId, [args]);
        return (_a = sdk2.editorExtension).createContentExtension.apply(_a, args);
      }, "createContentExtension"),
      /**
       * 创建服务插件
       */
      createServiceExtension: /* @__PURE__ */ __name(function() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("createServiceExtension", sdkOptions.appId, [args]);
        return (_a = sdk2.editorExtension).createServiceExtension.apply(_a, args);
      }, "createServiceExtension"),
      /**
       * 创建服务插件（带版本号）
       */
      createServiceExtensionWithVersion: /* @__PURE__ */ __name(function() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        args.debug = debug;
        var version = sdk_1.VersionOfCreateServiceExtension;
        (0, common_1.getWindowSDK)().getExtensionLoader().setApiParam("createServiceExtensionWithVersion", sdkOptions.appId, [__spreadArray([version], args, true)]);
        return (_a = sdk2.editorExtension).createServiceExtensionWithVersion.apply(_a, __spreadArray([version], args, false));
      }, "createServiceExtensionWithVersion"),
      /**
       * 创建一个数据节点操作器
       */
      useTransform: /* @__PURE__ */ __name(function() {
        return sdk2.editorExtension.useTransform();
      }, "useTransform"),
      /**
       * 创建数据节点
       */
      createNode: /* @__PURE__ */ __name(function() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return (_a = sdk2.editorExtension).createNode.apply(_a, args);
      }, "createNode")
    };
  }
  __name(getEditorExtension, "getEditorExtension");
  return editorExtension;
}
__name(requireEditorExtension, "requireEditorExtension");
var editor = {};
var hasRequiredEditor;
function requireEditor() {
  if (hasRequiredEditor) return editor;
  hasRequiredEditor = 1;
  Object.defineProperty(editor, "__esModule", { value: true });
  editor.getEditor = getEditor;
  function getEditor(sdk2) {
    var _a, _b, _c, _d;
    return {
      node: (_a = sdk2 === null || sdk2 === void 0 ? void 0 : sdk2.editor) === null || _a === void 0 ? void 0 : _a.node,
      MorphoAPI: (_b = sdk2 === null || sdk2 === void 0 ? void 0 : sdk2.editor) === null || _b === void 0 ? void 0 : _b.MorphoAPI,
      selection: (_c = sdk2 === null || sdk2 === void 0 ? void 0 : sdk2.editor) === null || _c === void 0 ? void 0 : _c.selection,
      jsonBuilder: (_d = sdk2 === null || sdk2 === void 0 ? void 0 : sdk2.editor) === null || _d === void 0 ? void 0 : _d.jsonBuilder
    };
  }
  __name(getEditor, "getEditor");
  return editor;
}
__name(requireEditor, "requireEditor");
var extension = {};
var hasRequiredExtension;
function requireExtension() {
  if (hasRequiredExtension) return extension;
  hasRequiredExtension = 1;
  Object.defineProperty(extension, "__esModule", { value: true });
  extension.OpenApiBaseUrlMap = extension.devToolId = extension.ExtensionInfoConfig = void 0;
  extension.ExtensionInfoConfig = [
    // {
    //   name: "release-log",
    //   id: "001",
    //   resources: {
    //     js: [
    //       'https://ku-tools-rd.bj.bcebos.com/rl-wiki-rd/ku-tools-rd/ku-release-log.js',
    //     ],
    //   },
    // },
  ];
  extension.devToolId = "__dev_tool__";
  extension.OpenApiBaseUrlMap = {
    rd: "https://ku-open-api-dev1.dev.weiyun.baidu.com",
    qa: "https://ku-open-api-qa1.dev.weiyun.baidu.com",
    gray: "https://ku-open-sdk.baidu-int.com/gray/api",
    online: "https://ku-open-sdk.baidu-int.com/api"
  };
  return extension;
}
__name(requireExtension, "requireExtension");
var event = {};
var hasRequiredEvent;
function requireEvent() {
  if (hasRequiredEvent) return event;
  hasRequiredEvent = 1;
  Object.defineProperty(event, "__esModule", { value: true });
  event.EventKeys = void 0;
  var EventKeys;
  (function(EventKeys2) {
    EventKeys2["DOC_READY"] = "DOC_READY";
    EventKeys2["DOC_SELECTION"] = "DOC_SELECTION";
    EventKeys2["DOC_SAVE"] = "DOC_SAVE";
    EventKeys2["ROOT_READY"] = "ROOT_READY";
    EventKeys2["NEW_VERSION"] = "NEW_VERSION";
  })(EventKeys || (event.EventKeys = EventKeys = {}));
  return event;
}
__name(requireEvent, "requireEvent");
var doc = {};
var hasRequiredDoc;
function requireDoc() {
  if (hasRequiredDoc) return doc;
  hasRequiredDoc = 1;
  Object.defineProperty(doc, "__esModule", { value: true });
  doc.DOC_MODE = void 0;
  var DOC_MODE;
  (function(DOC_MODE2) {
    DOC_MODE2["preview"] = "preview";
    DOC_MODE2["edit"] = "edit";
    DOC_MODE2["meeting"] = "meeting";
    DOC_MODE2["history"] = "history";
  })(DOC_MODE || (doc.DOC_MODE = DOC_MODE = {}));
  return doc;
}
__name(requireDoc, "requireDoc");
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist;
  hasRequiredDist = 1;
  (function(exports) {
    var __assign = dist && dist.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DOC_MODE = exports.EventKeys = exports.createBlockSDK = exports.createSDK = void 0;
    var doc_1 = requireDoc$1();
    var repository_1 = requireRepository();
    var component_1 = requireComponent();
    var user_1 = requireUser();
    var utils_1 = requireUtils$2();
    var init_1 = requireInit();
    var log_1 = requireLog();
    var bus_1 = requireBus();
    var blockSdk_1 = requireBlockSdk();
    Object.defineProperty(exports, "createBlockSDK", { enumerable: true, get: /* @__PURE__ */ __name(function() {
      return blockSdk_1.createBlockSDK;
    }, "get") });
    var editor_extension_1 = requireEditorExtension();
    var editor_1 = requireEditor();
    var extension_1 = requireExtension();
    var common_1 = requireCommon();
    var filterFnList = ["initDropMenuTool", "initSideBarTool"];
    function preInvoke(fnName, fnParams, toolId, debug) {
      if (debug) {
        return;
      }
      if ((0, common_1.isNoNeedLog)(fnName)) {
        return;
      }
      console.log("[ku-tool-sdk]: 方法 ".concat(fnName, " 被调用了， 参数是:"), fnParams, "工具 ID 为：".concat(toolId));
    }
    __name(preInvoke, "preInvoke");
    function createProxy(obj, root, debug) {
      root = root || obj;
      var handler = {
        get: /* @__PURE__ */ __name(function(target, prop) {
          var value = target[prop];
          if (typeof value === "function") {
            if (filterFnList.includes(prop)) {
              return value;
            } else {
              return function() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }
                preInvoke(prop, args, root.id, debug);
                return value.apply(target, args);
              };
            }
          } else if (typeof value === "object" && value !== null) {
            return createProxy(value, root, debug);
          }
          return value;
        }, "get")
      };
      return new Proxy(obj, handler);
    }
    __name(createProxy, "createProxy");
    var proxyInstance = null;
    var createSDK = /* @__PURE__ */ __name(function(options) {
      var _a, _b, _c;
      if (!proxyInstance) {
        var debug = Boolean(process.env.DEBUG_KU_EXTENSION);
        options.appId = (debug ? extension_1.devToolId : options === null || options === void 0 ? void 0 : options.appId) || "";
        var sdk2 = (_a = window.__KU_TOOL_SDK__) === null || _a === void 0 ? void 0 : _a.createSDK(__assign(__assign({}, options), { debug }));
        var doc2 = (0, doc_1.getDoc)(sdk2);
        var repository2 = (0, repository_1.getRepository)(sdk2);
        var component2 = (0, component_1.getComponent)(sdk2);
        var user2 = (0, user_1.getUser)(sdk2);
        var utils2 = (0, utils_1.getUtils)(sdk2);
        var editorExtension2 = (0, editor_extension_1.getEditorExtension)(sdk2, options, debug);
        var editor2 = (0, editor_1.getEditor)(sdk2);
        var event_2 = (0, bus_1.getKuToolEvent)(options, debug);
        var instance = {
          id: (options === null || options === void 0 ? void 0 : options.appId) || "",
          doc: doc2,
          repository: repository2,
          component: component2,
          user: user2,
          utils: utils2,
          appLog: log_1.appLog,
          event: event_2,
          editorExtension: editorExtension2,
          editor: editor2,
          debug
        };
        var extensionLoader = (_c = (_b = window.__KU_TOOL_SDK__) === null || _b === void 0 ? void 0 : _b.getExtensionLoader) === null || _c === void 0 ? void 0 : _c.call(_b);
        instance.slot = (0, init_1.getSlot)(instance, extensionLoader, sdk2);
        proxyInstance = createProxy(instance, void 0, debug);
      }
      return proxyInstance;
    }, "createSDK");
    exports.createSDK = createSDK;
    var event_1 = requireEvent();
    Object.defineProperty(exports, "EventKeys", { enumerable: true, get: /* @__PURE__ */ __name(function() {
      return event_1.EventKeys;
    }, "get") });
    var doc_2 = requireDoc();
    Object.defineProperty(exports, "DOC_MODE", { enumerable: true, get: /* @__PURE__ */ __name(function() {
      return doc_2.DOC_MODE;
    }, "get") });
  })(dist);
  return dist;
}
__name(requireDist, "requireDist");
var distExports = requireDist();
const extractCommentFromJson = /* @__PURE__ */ __name((comment) => {
  try {
    const parsedComment = JSON.parse(comment);
    if (!Array.isArray(parsedComment)) {
      return comment + "";
    }
    if (parsedComment.length === 0) {
      return "";
    }
    const textList = [];
    parsedComment.forEach((item) => {
      if (item?.type === "paragraph") {
        const text = item.children.reduce((prev, cur) => {
          if (cur?.type === "mention") {
            return prev + "@" + (cur.mentionName || "");
          } else if (cur?.type === "link") {
            return prev + (cur.title || "");
          }
          return prev + (cur?.text || "");
        }, "");
        if (text) {
          textList.push(text);
        }
      } else if (item?.type === "image") {
        textList.push("[图片]");
      }
    });
    return textList.join("\n");
  } catch (e) {
    return comment;
  }
}, "extractCommentFromJson");
const extractSecondToLastSegment = /* @__PURE__ */ __name((url) => {
  try {
    const urlObj = new URL(url);
    const segments = urlObj.pathname.split("/").filter((segment) => segment !== "");
    if (segments.length < 2) {
      return null;
    }
    return segments[segments.length - 2];
  } catch (error) {
    return null;
  }
}, "extractSecondToLastSegment");
const KV_LOG_ID = "80001.2.378";
const createLogger = /* @__PURE__ */ __name((blockAPI) => {
  return {
    log: /* @__PURE__ */ __name((repId, params) => {
      blockAPI.utils.kuLogger({
        repId,
        params
      });
    }, "log")
  };
}, "createLogger");
const createKVLogger = /* @__PURE__ */ __name((blockAPI, builderId) => {
  const logger = createLogger(blockAPI);
  let recentClickTime = null;
  document.body.addEventListener("click", (ev) => {
    if (ev?.target?.tagName === "BUTTON") {
      logger.log("80001.8.322", {
        builderId,
        text: ev.target.textContent.slice(0, 50)
      });
    }
    recentClickTime = Date.now();
  }, { capture: true });
  return (type) => {
    const clickDuration = Date.now() - recentClickTime;
    const routes = [];
    if (clickDuration <= 1e3) {
      routes.push("click_1");
    } else if (clickDuration <= 2e3) {
      routes.push("click_2");
    } else if (clickDuration <= 5e3) {
      routes.push("click_5");
    }
    logger.log(KV_LOG_ID, {
      builderId,
      type,
      routes: routes.length > 0 ? routes : void 0
    });
  };
}, "createKVLogger");
const GetItemBucketLimiter = {
  name: "get-item-bucket",
  capacity: 80,
  refillRate: 40,
  cost: 1
};
const SetItemBucketLimiter = {
  name: "set-item-bucket",
  capacity: 40,
  refillRate: 20,
  cost: 1
};
const GetAllKeysBucketLimiter = {
  name: "get-all-keys-bucket",
  capacity: 80,
  refillRate: 40,
  cost: 1
};
const RemoveItemBucketLimiter = {
  name: "remove-item-bucket",
  capacity: 40,
  refillRate: 20,
  cost: 1
};
const ClearBucketLimiter = {
  name: "clear-bucket",
  capacity: 40,
  refillRate: 20,
  cost: 1
};
const CommentLimiter = {
  name: "get-comments",
  capacity: 10,
  refillRate: 5,
  cost: 1
};
const AILimiter = {
  name: "ai",
  capacity: 10,
  refillRate: 1,
  cost: 1
};
const UploadFileLimiter = {
  name: "upload-file",
  capacity: 10,
  refillRate: 1,
  cost: 1
};
const WikiHostPlugin = {
  injectApi(bridge2, params) {
    const {
      builderId,
      getRenderProps,
      bucketManager = null
    } = params || {};
    const BlockAPI = distExports.createBlockSDK({ appId: "flex-builder" });
    const RTE_SERVER = `https://${"rte.weiyun.baidu.com"}`;
    const SAFE_KU_SERVER = `https://${"ku.baidu-int.com"}`;
    const KU_SERVER = `http://${"ku.baidu-int.com"}`;
    const PROXY_URL = `${RTE_SERVER}/daas/api/trans/request`;
    const isKuServer = /* @__PURE__ */ __name((url) => {
      return url?.startsWith(SAFE_KU_SERVER) || url?.startsWith(KU_SERVER);
    }, "isKuServer");
    const kvLogger = createKVLogger(BlockAPI, builderId);
    const withRateLimiter = /* @__PURE__ */ __name((config, fn) => {
      if (!bucketManager) {
        return fn;
      }
      bucketManager.getOrCreateBucket(config.name, {
        capacity: config.capacity,
        refillRate: config.refillRate
      });
      return (...args) => {
        if (!bucketManager.tryAcquire(config.name, config.cost)) {
          bridge2.callApi("rate-limit", {
            message: `[随心搭] 单随心搭限流: id:${builderId}, bucket:${config.name}`
          });
          return;
        }
        return fn(...args);
      };
    }, "withRateLimiter");
    const getAllKeys = /* @__PURE__ */ __name(async (preKey, options) => {
      try {
        kvLogger("getAllKeys");
        return BlockAPI.utils.rteRequest({
          method: "GET",
          url: `/daas/api/storage/${builderId}`,
          params: {
            key_prefix: preKey,
            page: options?.page,
            page_size: options?.size
          }
        });
      } catch (e) {
        console.error(e);
      }
    }, "getAllKeys");
    const getItem = /* @__PURE__ */ __name((key) => {
      const encodeKey = encodeURIComponent(key);
      try {
        kvLogger("getItem");
        return BlockAPI.utils.rteRequest({
          method: "GET",
          url: `/daas/api/storage/${builderId}/${encodeKey}`
        });
      } catch (e) {
        console.error(e);
      }
    }, "getItem");
    const setItem = /* @__PURE__ */ __name(async (key, value) => {
      const encodeKey = encodeURIComponent(key);
      try {
        kvLogger("setItem");
        return BlockAPI.utils.rteRequest({
          method: "POST",
          url: `/daas/api/storage/${builderId}/${encodeKey}`,
          data: {
            value
          }
        });
      } catch (e) {
        console.error(e);
      }
    }, "setItem");
    const removeItem = /* @__PURE__ */ __name(async (key) => {
      const encodeKey = encodeURIComponent(key);
      try {
        kvLogger("removeItem");
        return BlockAPI.utils.rteRequest({
          method: "DELETE",
          url: `/daas/api/storage/${builderId}/${encodeKey}`
        });
      } catch (e) {
        console.error(e);
      }
    }, "removeItem");
    const clear = /* @__PURE__ */ __name(async () => {
      try {
        kvLogger("clear");
        return BlockAPI.utils.rteRequest({
          method: "DELETE",
          url: `/daas/api/storage/${builderId}`
        });
      } catch (e) {
        console.error(e);
      }
    }, "clear");
    const getComments = /* @__PURE__ */ __name(async (type) => {
      if (type !== 1 && type !== 2) {
        type = void 0;
      }
      const docInfo = await BlockAPI.doc.getDocBaseInfo();
      const repoId = extractSecondToLastSegment(docInfo.docUrl);
      return BlockAPI.utils.rteRequest({
        method: "GET",
        url: `/daas/api/tool/doc/${repoId}/${docInfo.docId}/comments?limit=500${type > 0 ? "&type=" + type : ""}`
      }).then((res) => {
        return {
          commentList: res.commentList.map((comment) => ({
            id: comment.id,
            // 将 id 从字符串转为唯一数字（假设使用 base36 转换）
            content: extractCommentFromJson(comment.content),
            // 提取 content 中的文字内容
            avatar: comment.avatar,
            author: comment.author,
            email: comment.email,
            createdAt: comment.createdAt,
            replyId: comment.replyId,
            // 如果有 replyId，则转换为数字；否则为 0
            type: comment.type
            // 保留 type 字段, 1:底部评论，2:划线评论
          })),
          commentCount: res.commentCount
          // 保留 commentCount
        };
      });
    }, "getComments");
    const AI = /* @__PURE__ */ __name((prompt, options) => {
      const {
        sys,
        temperature,
        model,
        messages
      } = options || {};
      return BlockAPI.utils.rteRequest({
        method: "POST",
        url: `/daas/api/tool/ai/${builderId}/generate`,
        data: {
          question: prompt,
          model,
          systemPrompt: sys,
          temperature,
          messages
        },
        timeout: 5 * 60 * 1e3
      });
    }, "AI");
    const uploadFile = /* @__PURE__ */ __name(async (file, options) => {
      const { key } = options || {};
      const formData = new FormData();
      formData.append("file", file);
      if (key) {
        formData.append("key", key);
      }
      const token = await BlockAPI.doc.getDocToken();
      return await fetch(`${RTE_SERVER}/daas/api/storage/${builderId}/file/upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: token
        }
      }).then((res) => res.json()).then((data) => {
        if (data.code !== 200) {
          throw new Error(data.message || "上传失败");
        }
        return data.data;
      });
    }, "uploadFile");
    return {
      Ku: {
        dataStorage: {
          getAllKeys: withRateLimiter(GetAllKeysBucketLimiter, getAllKeys),
          getItem: withRateLimiter(GetItemBucketLimiter, getItem),
          setItem: withRateLimiter(SetItemBucketLimiter, setItem),
          removeItem: withRateLimiter(RemoveItemBucketLimiter, removeItem),
          clear: withRateLimiter(ClearBucketLimiter, clear)
        },
        // 获取用户信息
        async getUserInfo() {
          const userInfo = await BlockAPI.user.getUserInfo();
          return {
            guid: userInfo.userGuid,
            name: userInfo.name,
            nickname: userInfo.nickname,
            avatar: userInfo.avatar,
            email: userInfo.email
          };
        },
        // 获取底部 + 划线评论 0: 全部 1: 底部评论 2: 划线评论
        getComments: withRateLimiter(CommentLimiter, getComments),
        // 获取当前文档的标题、作者邮箱、内容、创建时间、更新时间、当前状态（包括只读态和编辑态）
        async getDocInfo(format = "md") {
          const docType = format === "md" ? "markdown" : format;
          return Promise.all([
            BlockAPI.doc.getDocBaseInfo(),
            BlockAPI.doc.getDocContent({ type: docType }),
            BlockAPI.user.getCreatorInfo(),
            BlockAPI.doc.getDocMode()
          ]).then(([docInfo, docContent, creatorInfo, docMode]) => {
            const { readOnly } = getRenderProps() || {};
            const status = typeof readOnly === "boolean" ? readOnly ? "readonly" : "edit" : ["edit", "meeting"].includes(docMode) ? "edit" : "readonly";
            return {
              title: docInfo.title,
              name: creatorInfo.name,
              docId: docInfo.docId,
              nickname: creatorInfo.nickname,
              avatar: creatorInfo.avatar,
              author: creatorInfo.email,
              docContent,
              createTime: docInfo.createTime,
              status
            };
          });
        },
        // 大模型请求
        AI: withRateLimiter(AILimiter, AI),
        // 流式调用大模型
        async *streamAI(prompt, options) {
          const {
            sys,
            temperature,
            model,
            messages
          } = options || {};
          const token = await BlockAPI.doc.getDocToken();
          const response = await fetch(`${RTE_SERVER}/daas/api/tool/ai/${builderId}/completions`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token
            },
            body: JSON.stringify({
              prompt,
              model,
              systemPrompt: sys,
              temperature,
              messages
            })
          });
          const reader = response.body?.getReader();
          if (!reader) {
            throw new Error("Failed to get reader");
          }
          const decoder = new TextDecoder("utf-8");
          let done = false;
          while (!done) {
            const { value, done: readerDone } = await reader.read();
            done = readerDone;
            if (readerDone) {
              return;
            }
            const chunk = decoder.decode(value, { stream: true });
            yield chunk;
          }
        },
        // 上传
        uploadFile: withRateLimiter(UploadFileLimiter, uploadFile),
        // 带权限的API
        request: {
          async get(url, options) {
            const requestOption = {
              method: "GET",
              url,
              ...options
            };
            if (isKuServer(url)) {
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async post(url, data, options) {
            const requestOption = {
              method: "POST",
              url,
              data,
              ...options
            };
            if (isKuServer(url)) {
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async put(url, data, options) {
            const requestOption = {
              method: "PUT",
              url,
              data,
              ...options
            };
            if (isKuServer(url)) {
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async delete(url, options) {
            const requestOption = {
              method: "DELETE",
              url,
              ...options
            };
            if (isKuServer(url)) {
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async uploadFile(url, file) {
            const formData = new FormData();
            formData.append("file", file);
            const token = await BlockAPI.doc.getDocToken();
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "Authorization": token
              },
              body: formData
            });
            if (!response.ok) {
              throw new Error(`Failed to upload file: ${response.statusText}`);
            }
            const jsonData = await response.json();
            return jsonData.data;
          }
        },
        // 系统提示词里没有这个，目前只是担心AI用错做个兜底
        get isMobile() {
          const { isMobile } = getRenderProps() || {};
          return isMobile;
        },
        // 接口代理
        proxy: {
          async get(options) {
            const { url, ...rest } = options || {};
            const requestOption = {
              ...rest,
              method: "GET",
              url: `${PROXY_URL}?url=${encodeURIComponent(url)}&builderId=${builderId}`,
              returnOriginData: true
            };
            if (isKuServer(url)) {
              requestOption.headers = requestOption.headers || {};
              requestOption.headers["Authorization"] = await BlockAPI.doc.getDocToken();
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async post(options) {
            const { url, data, ...rest } = options || {};
            const requestOption = {
              ...rest,
              method: "POST",
              url: `${PROXY_URL}?url=${encodeURIComponent(url)}&builderId=${builderId}`,
              data,
              returnOriginData: true
            };
            if (isKuServer(url)) {
              requestOption.headers = requestOption.headers || {};
              requestOption.headers["Authorization"] = await BlockAPI.doc.getDocToken();
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async put(options) {
            const { url, data, ...rest } = options || {};
            const requestOption = {
              ...rest,
              method: "PUT",
              url: `${PROXY_URL}?url=${encodeURIComponent(url)}&builderId=${builderId}`,
              data,
              returnOriginData: true
            };
            if (isKuServer(url)) {
              requestOption.headers = requestOption.headers || {};
              requestOption.headers["Authorization"] = await BlockAPI.doc.getDocToken();
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          },
          async delete(options) {
            const { url, ...rest } = options || {};
            const requestOption = {
              ...rest,
              method: "DELETE",
              url: `${PROXY_URL}?url=${encodeURIComponent(url)}&builderId=${builderId}`,
              returnOriginData: true
            };
            if (isKuServer(url)) {
              requestOption.headers = requestOption.headers || {};
              requestOption.headers["Authorization"] = await BlockAPI.doc.getDocToken();
              return BlockAPI.utils.ksRequest(requestOption);
            }
            return BlockAPI.utils.rteRequest(requestOption);
          }
        }
      }
    };
  }
};
const WikiClientPlugin = {
  setupBridge(bridge2) {
    bridge2.registerApi("rate-limit", (data) => {
      const {
        message
      } = data || {};
      window.console.error(new Error(message || ""));
    });
  }
};
const EditorHostPlugin = {
  injectApi(bridge2) {
    return {
      Ku: {
        editor: {
          transform: {
            async insertNodes(nodes, options) {
              return bridge2.callApi("editor-op", {
                type: "insertNodes",
                nodes,
                options
              });
            },
            async setNodes(nodes, options) {
              return bridge2.callApi("editor-op", {
                type: "setNodes",
                nodes,
                options
              });
            },
            async removeNodes(options) {
              return bridge2.callApi("editor-op", {
                type: "removeNodes",
                options
              });
            },
            async setSelection(options) {
              return bridge2.callApi("editor-op", {
                type: "setSelection",
                options
              });
            },
            // 根据path获取节点信息
            async get(path) {
              return bridge2.callApi("editor-get", {
                path
              });
            }
          },
          on: /* @__PURE__ */ __name((callback) => {
            bridge2.on("morpho-editor-event", callback);
          }, "on")
        }
      }
    };
  }
};
const EditorClientPlugin = {
  setupBridge(bridge2) {
    bridge2.registerApi("editor-op", (data) => {
      const editor2 = window.morphoEditor || window.baiduRteStore.STORE_EDITOR;
      const { type, nodes, options } = data || {};
      if (!editor2 || !type || !options) {
        return;
      }
      if (nodes) {
        editor2.getTransformService()[type](nodes, options);
      } else {
        editor2.getTransformService()[type](options);
      }
    });
    bridge2.registerApi("editor-get", (data) => {
      const editor2 = window.morphoEditor || window.baiduRteStore.STORE_EDITOR;
      const { path } = data || {};
      if (!editor2 || !Array.isArray(path)) {
        return;
      }
      if (path.length === 0) {
        return editor2.children;
      }
      let node = editor2;
      while (path.length > 0) {
        node = node.children[path.shift()];
      }
      return node;
    });
  }
};
function createDeepProxy(callback, path = "") {
  const handler = {
    get(obj, prop) {
      const currentPath = path ? `${path}.${prop}` : prop;
      return createDeepProxy(callback, currentPath);
    },
    apply(target, thisArg, args) {
      let result;
      if (callback) {
        result = callback(path, args);
      } else {
        console.log(`${path}()`);
      }
      return result !== void 0 ? result : createDeepProxy(callback, path);
    }
  };
  return new Proxy(function() {
  }, handler);
}
__name(createDeepProxy, "createDeepProxy");
function callFromWindow(path, args = []) {
  const pathParts = path.split(".");
  let current = window.BdHiJs;
  if (!current) {
    console.warn("window.BdHiJs 不存在");
    return;
  }
  for (let i = 0; i < pathParts.length - 1; i++) {
    const part = pathParts[i];
    if (!(part in current)) {
      console.warn(`${pathParts.slice(0, i + 1).join(".")} 不存在`);
      return;
    }
    current = current[part];
    if (current === null || typeof current !== "object" && typeof current !== "function") {
      console.warn(`${pathParts.slice(0, i + 1).join(".")} not a object`);
      return;
    }
  }
  const lastPart = pathParts[pathParts.length - 1];
  if (!(lastPart in current)) {
    console.warn(`${path} 不存在`);
    return;
  }
  const target = current[lastPart];
  if (target === void 0) {
    console.warn(`${path} is undefined`);
    return;
  }
  if (typeof target === "function") {
    return target(...args);
  }
  return target;
}
__name(callFromWindow, "callFromWindow");
const BdHiJsHostPlugin = {
  injectApi(bridge2) {
    const cb = /* @__PURE__ */ __name((path, args) => {
      return bridge2.callApi("BdHiJs", {
        path,
        args
      });
    }, "cb");
    return {
      BdHiJs: createDeepProxy(cb)
    };
  }
};
const BdHiJsClientPlugin = {
  setupBridge(bridge2) {
    bridge2.registerApi("BdHiJs", (data) => {
      if (typeof window.BdHiJs !== "undefined") {
        const { path, args } = data || {};
        return callFromWindow(path, args);
      }
    });
  }
};
export {
  BdHiJsHostPlugin as B,
  EditorHostPlugin as E,
  WikiHostPlugin as W,
  EditorClientPlugin as a,
  BdHiJsClientPlugin as b,
  WikiClientPlugin as c
};
//# sourceMappingURL=BdHiJs-DSYXPf2b.js.map
